import React from "react";

/** Лаконичный колокольчик в стиле HeaderNavIcon (stroke, 24×24). */
export default function HeaderAlertIcon({ className = "" }) {
  return (
    <span
      className={`header-nav-icon header-alert-bell${className ? ` ${className}` : ""}`}
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 24 24"
        width="22"
        height="22"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
        <path d="M13.73 21a2 2 0 0 1-3.46 0" />
      </svg>
    </span>
  );
}
